import React, { useEffect, useState } from "react";
import styles from "./ClientHome.module.css";
import { Box, TextComponent } from "../../../components";
import cplImg1 from "../../../assets/staticImages/cplImage1.png";
import cplImg2 from "../../../assets/staticImages/cplImage2.png";
import ProgressBar from "@ramonak/react-progress-bar";
import { MdEdit, MdOutlineAddBox } from "react-icons/md";
import { Col, List, Row } from "antd";
import { BsCheckCircle, BsCheckCircleFill } from "react-icons/bs";
import photo from "../../../assets/staticImages/photo.png";
import wardrobe from "../../../assets/staticImages/wardrobe.png";
import deco from "../../../assets/staticImages/deco.png";
import dj from "../../../assets/staticImages/dj.png";
import { useNavigate } from "react-router-dom";
// import { timeLeft } from "../EventDetail/eventOverview/Data";
import weddingImg from "../../../assets/dashbordImg.png";
import { GiCircle } from "react-icons/gi";
import { RiDeleteBinLine } from "react-icons/ri";
import { BiSolidEdit } from "react-icons/bi";
import { AuthMiddleware } from "../../../Store/Middlewares/AuthMiddleware";
import { useDispatch, useSelector } from "react-redux";
import { DashBoardMiddleware } from "../../../Store/Middlewares/DashBoardMiddleware";
import CoverPlaceholder from "../../../assets/integrationImg/cover-placeholder-image.jpg";
import moment from "moment";
import { showRinging } from "../../../Store/Actions/GeneralActions";

const RenderChecklist = ({ item }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  // const [modalOpen, setModalOpen] = useState(false);
  // const navigate = useNavigate();
  const dispatch = useDispatch();

  function handleDropdown(e) {
    e.stopPropagation();
    setDropdownOpen((prev) => !prev);
  }

  useEffect(() => {
    dispatch(AuthMiddleware.getUserData());
    document.body.addEventListener("click", () => setDropdownOpen(false));

    return () => {
      document.body.addEventListener("click", () => setDropdownOpen(false));
    };
  }, []);

  // const getNotification = () => {

  //   messaging().onNotificationOpenedApp(message => {
  //     if (message.notification.title.toLowerCase().includes('incoming video call')) {
  //       navigation.navigate('IncommingCall', { data: message?.data })
  //     }
  //   });

  //   messaging().getInitialNotification(message => {
  //     if (message.notification.title.toLowerCase().includes('incoming video call')) {
  //       navigation.navigate('IncommingCall', { data: message?.data })
  //     }
  //   });

  //   notifee.onForegroundEvent(async ({ type, detail }) => {
  //     const data = detail?.notification?.data;
  //     if (detail.notification.title.toLowerCase().includes('incoming video call')) {
  //       navigation.navigate('IncommingCall', { data })
  //     }

  //   });
  // }
  return (
    <div className={styles.checklistMainCon}>
      <div className={styles.checkHead}>
        {item?.is_completed ? (
          <BsCheckCircleFill className={styles.checklistIcon} />
        ) : (
          // <BsCheckCircle className={styles.checklistIcon} />
          <GiCircle className={styles.checklistIcon} />
        )}
        <div className={styles.checklistContent}>
          <TextComponent text={item?.name} textClass={styles.checklistHead} />
          {/* <div className={styles.checklistDate}>
            <TextComponent text={"Due: "} textClass={styles.checklistDue} />
            <TextComponent
              text={
                item?.time ? moment(item?.time).format("MMM-DD-YYYY") : "N/A"
              }
              textClass={styles.checklistDateText}
            />
          </div> */}
        </div>
      </div>
      {/* <TextComponent textClass={styles.dropdownBtn} onClick={handleDropdown}>
        ...
      </TextComponent> */}
      {/* {dropdownOpen && (
        <Row className={styles.dropdown}>
          <Row
            className={styles.dropdownItem}
            // onClick={() => setModalOpen(true)}
          >
            <RiDeleteBinLine fontSize="1.1rem" />
            <TextComponent textClass={styles.dropdownText}>
              Delete
            </TextComponent>
          </Row>
          <Row
            className={styles.dropdownItem}
            // onClick={() =>
            //   navigate("/events/eventDetail/editTask", {
            //     state: { headrTitle: "Edit Task" },
            //   })
            // }
          >
            <BiSolidEdit fontSize="1.1rem" />
            <TextComponent textClass={styles.dropdownText}>Edit</TextComponent>
          </Row>
        </Row>
      )} */}
    </div>
  );
};

const ClientHome = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const clientDashBoardData = useSelector(
    (state) => state.DashboardReducer?.clientDashboardData
  );

  const user = useSelector((state) => state?.AuthReducer?.user);
  const vendorTeamData = [
    {
      id: 1,
      name: "Photography",
      image: photo,
    },
    {
      id: 2,
      name: "Wardrobe",
      image: wardrobe,
    },
    {
      id: 3,
      name: "Decoration",
      image: deco,
    },
    {
      id: 4,
      name: "DJ",
      image: dj,
    },
  ];

  const getClientDashBoardData = () => {
    dispatch(DashBoardMiddleware.getClientDashBoard()).then((data) => {
      calculateTimeElapsed(data);
    });
  };

  console.log("clientDashBoardData", clientDashBoardData);
  // const startDate = moment(data?.count_down?.datetime);
  const [timeElapsed, setTimeElapsed] = useState({
    months: "00",
    days: "00",
    hours: "00",
    minutes: "00",
    seconds: "00",
  });
  // console.log("timeElpas",timeElapsed)
  let timerRef = null;
  function calculateTimeElapsed(data) {
    timerRef = setInterval(() => {
      var dur = moment.duration(
        moment(data?.count_down?.datetime).diff(moment())
      );
      console.log("dur=========>>>>>>>>", dur);
      
      let yearsRemain = dur.years();
      let months = dur.months();
      let days = dur.days();
      let hours = dur.hours();
      let minutes = dur.minutes();
      let seconds = dur.seconds();

      console.log(dur.asMonths());
      const timeObj = {
        months:
          months < 10 && yearsRemain == 0
            ? "0" + months
            : months + 12 * yearsRemain,
        days: days < 10 ? "0" + days : days,
        hours: hours < 10 ? "0" + hours : hours,
        minutes: minutes < 10 ? "0" + minutes : minutes,
        seconds: seconds < 10 ? "0" + seconds : seconds,
      };
      if (hours <= 0 && days <= 0 && months <= 0) {
        setTimeElapsed({
          months: "00",
          days: "00",
          hours: "00",
          minutes: "00",
          seconds: "00",
        });
        clearInterval(timerRef);
      } else {
        setTimeElapsed(timeObj);
      }
    }, 1000);
  }
  // console.log('timeeeeObjjjjjjjjjj', timeElapsed);
  const timeLeft = [
    {
      title: "Mon",
      duration: clientDashBoardData?.is_count_down ? timeElapsed?.months : "00",
    },
    {
      title: "Days",
      duration: clientDashBoardData?.is_count_down ? timeElapsed?.days : "00",
    },
    {
      title: "Hrs",
      duration: clientDashBoardData?.is_count_down ? timeElapsed?.hours : "00",
    },
    // {
    //   title: "Min",
    //   duration: clientDashBoardData?.is_count_down
    //     ? timeElapsed?.minutes
    //     : "00",
    // },
    // {
    //   title: "Sec",
    //   duration: clientDashBoardData?.is_count_down
    //     ? timeElapsed?.seconds
    //     : "00",
    // },
  ];

  useEffect(() => {
    getClientDashBoardData();

    return () => clearInterval(timerRef);
  }, []);

  const renderBudget = (item) => {
    return (
      <div className={styles.bgtMainCon}>
        <div className={styles.subBgtCon}>
          <div>
            <TextComponent
              text={item?.category?.name}
              textClass={styles.bgttext}
            />
            <TextComponent text={item?.title} textClass={styles.bgtnametext} />
          </div>
          <div>
            <div className={styles.prices}>
              <div className={styles.leftOne}>
                <TextComponent text={"$"} />
                <TextComponent text={item?.paid} />
              </div>
              <div className={styles.rightOne}>
                <TextComponent text={"/"} />
                <TextComponent text={"$"} />
                <TextComponent
                  text={
                    item?.actual_cost ? item?.actual_cost : item?.total_budget
                  }
                />
              </div>
            </div>
            <div className={styles.btmRight}>
              <TextComponent
                text={"Budget Left:"}
                textClass={styles.budgetTxt}
              />
              <div className={styles.bgtRemainTxt}>
                <TextComponent text={"$"} />
                <TextComponent
                  text={
                    clientDashBoardData?.budgets?.total_budget -
                    clientDashBoardData?.budgets?.paid
                  }
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderVendorTeam = (item) => {
    return (
      <div className={styles.VTmainCon}>
        <img src={item?.image} />
        <TextComponent text={item?.name} textClass={styles.VTtext} />
      </div>
    );
  };

  const stats = [
    {
      current:
        clientDashBoardData?.checklists?.length > 0
          ? clientDashBoardData?.checklists?.filter((data) => data.is_completed)
              ?.length
          : "0",
      total:
        clientDashBoardData?.checklists?.length > 0
          ? clientDashBoardData?.checklists?.length
          : "0",
    },
    {
      current: clientDashBoardData?.no_of_attendee
        ? clientDashBoardData?.no_of_attendee
        : "0",
      total: clientDashBoardData?.no_of_guest
        ? clientDashBoardData?.no_of_guest
        : "0",
    },
    {
      current: clientDashBoardData?.budgets?.paid
        ? clientDashBoardData?.budgets?.paid
        : "0",
      total: clientDashBoardData?.budgets?.total_budget
        ? clientDashBoardData?.budgets?.total_budget
        : "0",
    },
  ];

  const per = stats.map((data) => (data.current / data.total) * 100);

  const percentage = (per[0] + per[1] + per[2]) / 3;

  return (
    <div className={styles.mainCon}>
      <Box boxClass={styles.firstCon}>
        <Row className={styles.firstRow} gutter={[0, 16]}>
          <Col xs={24} lg={9} xl={7}>
            <TextComponent textClass={styles.titleText}>
              Welcome,{" "}
              <TextComponent textClass={styles.titleName}>
                {user?.first_name ? `${user?.first_name}!` : "Client!"}
              </TextComponent>
            </TextComponent>
            {clientDashBoardData?.count_down ? (
              <div className={styles.imageContainer}>
                <img
                  src={
                    clientDashBoardData?.image
                      ? clientDashBoardData?.image
                      : CoverPlaceholder
                  }
                  className={styles.dashBoardImg}
                  alt=""
                  style={{ width: "100%" }}
                />
                {/* <div className={styles.editCon}>
                  <div
                    className={styles.edit}
                    onClick={() =>
                      navigate("/events/eventDetail/editCountdown", {
                        state: { headrTitle: "Edit Countdown" },
                      })
                    }
                  >
                    <MdEdit color="var(--primary-color)" size={20} />
                  </div>
                </div> */}
                <div className={styles.imageText}>
                  <div
                    className={styles.countdownBtn}
                    onClick={() =>
                      navigate("/events/eventDetail/countdown", {
                        state: { eventData: clientDashBoardData },
                      })
                    }
                  >
                    <svg
                      className={styles.viewBtnIcon}
                      viewBox="0 0 29 28"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_1636_528)">
                        <path
                          d="M12.1938 0.637016C19.1003 0.594686 24.497 5.07801 25.5555 11.0748C25.8186 12.5661 25.8344 14.0491 25.5637 15.5396C25.5187 15.7869 25.4288 15.8678 25.1792 15.8619C24.53 15.8463 23.88 15.847 23.2308 15.8604C22.9647 15.8656 22.8987 15.8106 22.9527 15.5262C23.7076 11.5464 22.6011 8.16813 19.4931 5.51988C15.2171 1.87574 8.45154 2.57085 4.97093 6.9606C0.951324 12.0313 2.44537 19.2201 8.16593 22.2939C9.54977 23.0373 11.0438 23.4116 12.6158 23.4561C12.9059 23.4643 12.9667 23.5594 12.9584 23.8237C12.9397 24.4171 12.9337 25.0127 12.9607 25.6053C12.9749 25.9291 12.8909 26.0272 12.5514 26.0123C9.62024 25.8831 6.98748 24.9459 4.76028 23.0551C1.32015 20.1358 -0.235367 16.3892 0.239909 11.9318C0.661211 7.9795 2.64328 4.88566 5.9972 2.68373C8.1037 1.29945 10.4434 0.655582 12.1938 0.637016Z"
                          fill="white"
                        />
                        <path
                          d="M22.0805 19.6765C23.3474 19.6772 24.5445 20.1941 25.6495 20.9605C26.5963 21.6177 27.4112 22.4168 28.1578 23.2865C28.2351 23.3763 28.3423 23.4469 28.2148 23.5924C26.9951 24.9893 25.669 26.2511 23.8789 26.912C22.0167 27.599 20.2723 27.2744 18.6208 26.2652C17.4716 25.5627 16.5248 24.6336 15.6477 23.6288C15.5495 23.5167 15.5323 23.4402 15.6402 23.3177C16.731 22.0789 17.9147 20.9575 19.4357 20.2387C20.2356 19.8607 21.0984 19.6624 22.0805 19.6765ZM20.6389 23.4424C20.6224 24.1353 21.1989 24.7316 21.8968 24.7458C22.5835 24.7591 23.1907 24.1687 23.1997 23.4803C23.2079 22.8037 22.6412 22.2237 21.9538 22.2052C21.2469 22.1859 20.6546 22.7428 20.6389 23.4424Z"
                          fill="white"
                        />
                        <path
                          d="M11.6694 10.1648C11.6694 8.79166 11.6754 7.41777 11.6641 6.04463C11.6619 5.79436 11.7226 5.69485 11.994 5.70227C12.6304 5.71935 13.2676 5.71861 13.9048 5.70153C14.1687 5.69485 14.2414 5.78099 14.2399 6.03795C14.2302 7.90643 14.2422 9.77417 14.2272 11.6427C14.2249 11.9635 14.2984 12.0615 14.638 12.0585C16.5113 12.0407 18.3847 12.0556 20.2581 12.0452C20.5414 12.0437 20.6531 12.1068 20.6419 12.4098C20.6194 13.0403 20.6269 13.6715 20.6396 14.3028C20.6441 14.5308 20.5692 14.5976 20.3398 14.5969C17.5548 14.5902 14.7699 14.5887 11.985 14.5984C11.7009 14.5991 11.6649 14.4847 11.6671 14.2478C11.6739 12.8866 11.6694 11.5253 11.6694 10.1648Z"
                          fill="white"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_1636_528">
                          <rect
                            width="28.12"
                            height="26.64"
                            fill="white"
                            transform="translate(0.15625 0.636719)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                  <div className={styles.timeBoxesBg}></div>
                  <div className={styles.timeBoxes}>
                    {timeLeft.map((time) => (
                      <div className={styles.timeBox}>
                        <TextComponent textClass={styles.timeTitle}>
                          {time.title}
                        </TextComponent>
                        <TextComponent textClass={styles.timeDuration}>
                          {time.duration}
                        </TextComponent>
                      </div>
                    ))}
                  </div>
                  <div className={styles.lineSvgDiv}>
                    <svg
                      className={styles.lineSvg}
                      viewBox="0 0 240 41"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M68.5859 0.607422H11.6367C5.56159 0.607422 0.636719 5.53229 0.636719 11.6074V29.9509C0.636719 36.026 5.56158 40.9509 11.6367 40.9509H68.5859V38.9509H11.6367C6.66615 38.9509 2.63672 34.9215 2.63672 29.9509V11.6074C2.63672 6.63686 6.66616 2.60742 11.6367 2.60742H68.5859V0.607422ZM171.539 38.9509H228.637C233.607 38.9509 237.637 34.9215 237.637 29.9509V11.6074C237.637 6.63686 233.607 2.60742 228.637 2.60742H171.539V0.607422H228.637C234.712 0.607422 239.637 5.53229 239.637 11.6074V29.9509C239.637 36.0261 234.712 40.9509 228.637 40.9509H171.539V38.9509Z"
                        fill="var(--primary-color)"
                      />
                    </svg>
                  </div>
                  <div className={styles.date}>
                    {clientDashBoardData?.count_down?.datetime
                      ? moment(
                          clientDashBoardData?.count_down?.datetime
                        ).format("MMM DD YYYY")
                      : "MM DD, YYYY"}
                  </div>
                </div>
              </div>
            ) : (
              <div className={styles.imageContainer}>
                <TextComponent textClass={styles.countdownMsg}>
                  Please Create Your Wedding Countdown
                </TextComponent>
                <img
                  src={
                    clientDashBoardData?.image
                      ? clientDashBoardData?.image
                      : CoverPlaceholder
                  }
                  className={styles.dashBoardImg}
                  alt=""
                  style={{ width: "100%", marginTop: "5px" }}
                />
                <div className={styles.imageText}>
                  <div className={styles.timeBoxesBg}></div>
                  <div className={styles.timeBoxes}>
                    {timeLeft.map((time) => (
                      <div className={styles.timeBox}>
                        <TextComponent textClass={styles.timeTitle}>
                          {time.title}
                        </TextComponent>
                        <TextComponent textClass={styles.timeDuration}>
                          00
                        </TextComponent>
                      </div>
                    ))}
                  </div>
                  <div className={styles.lineSvgDiv}>
                    <svg
                      className={styles.lineSvg}
                      viewBox="0 0 240 41"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M68.5859 0.607422H11.6367C5.56159 0.607422 0.636719 5.53229 0.636719 11.6074V29.9509C0.636719 36.026 5.56158 40.9509 11.6367 40.9509H68.5859V38.9509H11.6367C6.66615 38.9509 2.63672 34.9215 2.63672 29.9509V11.6074C2.63672 6.63686 6.66616 2.60742 11.6367 2.60742H68.5859V0.607422ZM171.539 38.9509H228.637C233.607 38.9509 237.637 34.9215 237.637 29.9509V11.6074C237.637 6.63686 233.607 2.60742 228.637 2.60742H171.539V0.607422H228.637C234.712 0.607422 239.637 5.53229 239.637 11.6074V29.9509C239.637 36.0261 234.712 40.9509 228.637 40.9509H171.539V38.9509Z"
                        fill="var(--primary-color)"
                      />
                    </svg>
                  </div>
                  <div className={styles.date}>MM DD YYYY</div>
                  <div
                    className={styles.createCountdownBtn}
                    onClick={() =>
                      navigate("/events/eventDetail/createCountdown", {
                        state: {
                          headrTitle: "Create Countdown",
                          clientDashBoardData: clientDashBoardData,
                        },
                      })
                    }
                  >
                    <MdOutlineAddBox fontSize={"1.2rem"} /> Create
                  </div>
                </div>
              </div>
            )}
          </Col>
          <Col xs={24} lg={15} xl={17}>
            <div className={styles.firstRight}>
              <div className={styles.FRleft}>
                {clientDashBoardData?.bride && (
                  <div className={styles.coupleCon}>
                    <div className={styles.coupleImg}>
                      <img
                        src={
                          clientDashBoardData?.bride?.image
                            ? clientDashBoardData?.bride?.image
                            : cplImg1
                        }
                        className={styles.firstImg}
                      />
                      <img
                        src={
                          clientDashBoardData?.groom?.image
                            ? clientDashBoardData?.groom?.image
                            : cplImg2
                        }
                        className={styles.secondImg}
                      />
                    </div>
                    <TextComponent
                      text={`${clientDashBoardData?.bride?.name} & ${clientDashBoardData?.groom?.name}`}
                      textClass={styles.subHeading}
                    />
                    <TextComponent
                      text={
                        clientDashBoardData?.date
                          ? moment(clientDashBoardData?.date).format(
                              "MMM DD YYYY"
                            )
                          : "MM DD, YYYY"
                      }
                      textClass={styles.cplText}
                    />
                  </div>
                )}
                <div className={styles.mainBarCon}>
                  <div className={styles.subBarCon}>
                    <div className={styles.barTxt}>
                      <TextComponent
                        text={"Status"}
                        textClass={styles.barTxt}
                      />
                      <TextComponent
                        text={"Let’s Get Started!"}
                        textClass={styles.barTxt}
                      />
                    </div>
                    <ProgressBar
                      completed={percentage}
                      className={styles.bar}
                      maxCompleted={100}
                      labelClassName={styles.labelBar}
                      bgColor="var(--primary-color)"
                      height="10px"
                    />
                  </div>
                </div>
                <div className={styles.displayList}>
                  <div className={styles.subDL}>
                    <TextComponent
                      text={
                        clientDashBoardData?.checklists
                          ? ` ${
                              clientDashBoardData?.checklists?.filter(
                                (data) => data.is_completed
                              )?.length
                            } out of ${clientDashBoardData?.checklists?.length}`
                          : "No Checklist Added "
                      }
                      textClass={styles.barTxt}
                    />
                    <TextComponent
                      text={"Tasks Completed"}
                      textClass={styles.barTxt}
                    />
                  </div>
                  <div className={styles.subDL}>
                    <TextComponent
                      text={`${
                        clientDashBoardData?.no_of_attendee
                          ? clientDashBoardData?.no_of_attendee
                          : "0"
                      } out of ${
                        clientDashBoardData?.no_of_guest
                          ? clientDashBoardData?.no_of_guest
                          : "0"
                      }`}
                      textClass={styles.barTxt}
                    />
                    <TextComponent
                      text={"Guests Attending"}
                      textClass={styles.barTxt}
                    />
                  </div>
                  <div className={styles.subDL}>
                    <TextComponent
                      text={
                        clientDashBoardData?.budgets
                          ? `$${clientDashBoardData?.budgets?.paid} out of $${clientDashBoardData?.budgets?.total_budget}`
                          : "No Budged Added"
                      }
                      textClass={styles.barTxt}
                    />
                    <TextComponent
                      text={"Budget Utilized"}
                      textClass={styles.barTxt}
                    />
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
        {/* <div className={styles.firstLeft}></div> */}
      </Box>
      <div className={styles.secondCon}>
        <Box boxClass={styles.subSecCon}>
          <div className={styles.boxHead}>
            <TextComponent text={"Checklist"} textClass={styles.boxHeadTxt} />
            <TextComponent
              textClass={styles.viewAllText}
              onClick={() =>
                clientDashBoardData &&
                navigate("/events/eventDetail", {
                  state: {
                    activeKey: "9",
                    headrTitle: "Checklist",
                    id: clientDashBoardData?.id,
                    eventData: clientDashBoardData,
                  },
                })
              }
            >
              <span className={styles.viewAll}>View All</span>
              <span className={styles.viewAllIcon}>{">"}</span>
            </TextComponent>
          </div>
          <div className={styles.list}>
            <List
              itemLayout="vertical"
              dataSource={clientDashBoardData?.checklists?.filter(
                (data, i) => i < 2
              )}
              renderItem={(item) => <RenderChecklist item={item} />}
            />
          </div>
        </Box>
        <Box boxClass={styles.subSecCon}>
          <div className={styles.boxHead}>
            <TextComponent
              text={"Build your vendor team"}
              textClass={styles.boxHeadTxt}
            />
            <TextComponent
              textClass={styles.viewAllText}
              onClick={() =>
                clientDashBoardData &&
                navigate("/findVendors/EventVendors", {
                  state: {
                    headrTitle: "Vendors",
                    eventData: clientDashBoardData,
                  },
                })
              }
            >
              <span className={styles.viewAll}>View All</span>
              <span className={styles.viewAllIcon}>{">"}</span>
            </TextComponent>
          </div>
          <List
            grid={{ lg: 2, xxl: 2, xl: 2, xs: 2, md: 4, sm: 4 }}
            itemLayout="vertical"
            dataSource={vendorTeamData}
            renderItem={renderVendorTeam}
          />
        </Box>
        <Box boxClass={styles.subSecCon}>
          <div className={styles.boxHead}>
            <TextComponent text={"Budget"} textClass={styles.boxHeadTxt} />
            <TextComponent
              textClass={styles.viewAllText}
              onClick={() =>
                clientDashBoardData &&
                navigate("/events/eventDetail", {
                  state: {
                    activeKey: "3",
                    headrTitle: "Budget",
                    id: clientDashBoardData?.id,
                    eventData: clientDashBoardData,
                  },
                })
              }
            >
              <span className={styles.viewAll}>View All</span>
              <span className={styles.viewAllIcon}>{">"}</span>
            </TextComponent>
          </div>
          <div className={styles.list}>
            <List
              itemLayout="vertical"
              dataSource={clientDashBoardData?.budgets?.tracker?.filter(
                (data, i) => i < 2
              )}
              renderItem={renderBudget}
            />
          </div>
        </Box>
      </div>
    </div>
  );
};
export default ClientHome;
